import { makeStyles } from 'tss-react/mui';
import { colors, fontSizes, spacing } from '../../../styles/jss/variables';
import { getHeadingColor } from '../../../styles/jss/utils';
const useStyles = makeStyles()((theme, _params) => ({
    heading: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_lg), [theme.breakpoints.up('lg')]: Object.assign({}, theme.typography.xxl), [theme.breakpoints.up('xl')]: Object.assign({}, theme.typography.xxxl) }),
    headingColor: {
        color: getHeadingColor(_params === null || _params === void 0 ? void 0 : _params.textColour),
    },
    noBottomMargin: Object.assign({}, theme.typographySpacing.none),
    quoteContainer: {
        position: 'relative',
    },
    featureTitle: {
        marginBottom: spacing.xxs,
        [theme.breakpoints.up('xl')]: {
            marginBottom: '10px',
        },
    },
    quotationMark: {
        color: 'inherit',
        '& .material-icons': {
            fontSize: fontSizes.medium,
            [theme.breakpoints.up('md')]: {
                fontSize: fontSizes.xxxl,
            },
        },
    },
    openQuote: {
        transform: 'rotate(180deg)',
    },
    closeQuote: {
        width: '100%',
        flexDirection: 'initial',
        justifyContent: 'end',
        alignItems: 'center',
    },
    quote: {
        '& .material-icons': {
            fontSize: fontSizes.xl,
            [theme.breakpoints.up('md')]: {
                fontSize: fontSizes.xxl,
            },
            [theme.breakpoints.up('xl')]: {
                fontSize: theme.isFlyingFlowers ? '58px' : fontSizes.xxxxl,
            },
        },
    },
    largeAdvertisingHeading: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xxl_bold), theme.typographySpacing.xxl_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xxxxl), theme.typographySpacing.xxxxl_sm) }),
    standardHeading: Object.assign(Object.assign(Object.assign({}, theme.typography.medium_bold), theme.typographySpacing.medium_bold_sm), { [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.large_bold_sm), [theme.breakpoints.up('xl')]: Object.assign(Object.assign({}, theme.typography.xl_bold), theme.typographySpacing.xl_bold_sm) }),
    headingLine: {
        alignSelf: 'flex-start',
        marginBottom: spacing.xs,
        display: 'block',
        padding: spacing.xs,
        margin: 0,
        '&:first-child': {
            transform: 'rotate(358deg) translate(5px,5px)',
            transformOrigin: 'bottom left',
        },
    },
    newHeading: {
        marginBottom: 0,
    },
    COBALT: {
        backgroundColor: colors.cobalt[500],
    },
    JADE: {
        backgroundColor: colors.jade[500],
    },
    WILD_EXOTIC: {
        backgroundColor: colors.wildExotic[500],
    },
    BLACK: {
        color: colors.black[700],
    },
}));
export default useStyles;
